// extracted by mini-css-extract-plugin
export default {"highVolume":"hud_highVolume__QVLmk","mute":"hud_mute__oai9K"};